/* eslint-disable no-undef */
import $ from "jquery";
import ajax from "./data/_my-account";
import flatpickr from "flatpickr";

const loginRegister = () => {
  const init = () => {
    execute();
    comparePassword();
    defaultSelectNL();
    registerAccount();
    loginAccount();
  };

  const execute = () => {
    $(function () {
      $(".wrapper-account-page .js-btn-register").click(function () {
        $(".wrapper-account-page__register").addClass("active");
        $(".wrapper-account-page__login").removeClass("active");
        $(".wrapper-account-page__register-right img").show();
      });

      if ($(".js-change-password-confirm").length === 0) return;
      $(".js-change-password-confirm input#password_check").attr(
        "type",
        "password"
      );
    });
  };

  const comparePassword = () => {
    if ($(".js-change-password-confirm input#password_check").length === 0)
      return;
    let password1 = $(".js-change-password-confirm #reg_password").val();
    let password2 = $(".js-change-password-confirm input#password_check").val();

    $(".js-change-password-confirm #reg_password").on("change", function () {
      password1 = $(".js-change-password-confirm #reg_password").val();

      if (password1.length < 7) {
        $(".js-account_register")
          .find('input[type="submit"]')
          .addClass("disabled");
        $(".sevendigits").show();
      } else if (password1.length >= 7) {
        $(".js-account_register")
          .find('input[type="submit"]')
          .removeClass("disabled");
        $(".sevendigits").hide();
      }

      if (password1 != "" || password2 != "") {
        $(".js-change-password-confirm")
          .find('button[name="register"]')
          .attr("disabled", "disabled");

        if (!$(".warning").is(":visible")) {
          $(".js-change-password-confirm input#password_check")
            .parent("p")
            .find(".warning")
            .show();
        }
        if (password1 === password2) {
          $(".js-change-password-confirm")
            .find('button[name="register"]')
            .removeAttr("disabled");
          $(".warning").hide();
        }
      }
    });

    $(".js-change-password-confirm input#password_check").on(
      "change",
      function () {
        password2 = $(".js-change-password-confirm input#password_check").val();

        if (password1 !== "" || password2 != "") {
          $(".js-change-password-confirm")
            .find('button[name="register"]')
            .attr("disabled", "disabled");
          if ($(".warning").length <= 0) {
            $(".js-change-password-confirm input#password_check")
              .parent("p")
              .find(".warning")
              .show();
          }
          if (password1 === password2) {
            $(".js-change-password-confirm")
              .find('button[name="register"]')
              .removeAttr("disabled");
            $(".warning").hide();
          }
        }
      }
    );
  };

  const defaultSelectNL = () => {
    const el = {
      select: ".js-account_register select.select-country",
    };

    (($) => {
      $(window).on("load", function () {
        $(el.select).val("NL").trigger("change");
      });
    })(jQuery);
  };

  const registerAccount = () => {
    const el = {
      form: "form.js-account_register",
    };

    const field = {
      email: "#reg_email",
      first_name: "#reg_fname",
      last_name: "#reg_lname",
      password: "#reg_password",
      password_check: "#password_check",
      streetname: "#streetname",
      house_number: "#house-number",
      postcode: "#zipcode",
      phone: "#phone",
      city: "#city",
      country: "#country",
      btw: "#btw",
      optional: "#optional",
      prefix_name: "#reg_tussenv",
      address_1: "#reg_tussenv",
      born_date: "#reg_date",
    };

    $(window).on("load", function () {
      flatpickr(field.born_date, {
        dateFormat: "d-m-Y",
        disableMobile: true,
        altInput: true,
        altFormat: "d-m-Y",
        allowInput: true,
        onReady: function () {
          // Add an input event listener to validate the entered date
          document
            .getElementById("reg_date")
            .addEventListener("input", function (event) {
              const input = event.target;
              const value = input.value;

              // Use a regular expression to match the "d-m-Y" format
              const validFormat = /^(\d{1,2})-(\d{1,2})-(\d{4})$/.test(value);

              if (!validFormat) {
                // If the input doesn't match the format, clear the input
                input.value = "";
              }
            });
        },
        parseDate: (datestr) => {
          return new Date(
            datestr.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
          );
        },
      });
      // $(`${el.form} ${field.country}`).select2();
    });

    $(document).on("submit", el.form, (event) => {
      event.preventDefault();
      let data = new Object();
      const $form = $(event.target);

      $.each(field, (key, value) => {
        data[key] = $form.find(value).val();
      });

      data.is_subscribe = $form.find("#is_subscribe_mc43p").is(":checked")
        ? "1"
        : "0";

      $form.find(".password-wrapper").find("span.warning").hide();

      if (data.password !== data.password_check) {
        $form.find(".password-wrapper > span").show();
        return;
      }

      data.redirect_to = $form.data("redirect_to");

      ajax
        .register_account(data)
        .done((res) => {
          if (res.redirect_to) {
            location.href = res.redirect_to;
          }
        })
        .catch((xhr) => {
          const res = xhr.responseJSON;
          alert(res.message);
        });
    });
  };

  const loginAccount = () => {
    const field = {
      email: "#username",
      password: "#password",
      redirect: "[name='redirect']",
    };
    $(document).on("submit", "form.js-account-form-login", (event) => {
      event.preventDefault();
      const searchQuery = window.location.search;
      const query = new URLSearchParams(searchQuery);

      const $form = $(event.target);
      const email = $form.find(field.email).val();
      const password = $form.find(field.password).val();

      let redirect;
      if (query.get("redirect_to")) {
        redirect = query.get("redirect_to");
      } else {
        redirect = $form.find(field.redirect).val();
      }
      // const isCartPage = $form.find(field.redirect).hasClass('cartpage');
      ajax
        .login_account(email, password, { data: { redirect: redirect } })
        .done((res) => {
          if (res.redirect_to) {
            location.href = res.redirect_to;
          }
        })
        .catch((xhr) => {
          const res = xhr.responseJSON;
          alert(res.message);
        });
    });
  };

  init();
};

try {
  loginRegister();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
